<template>
<div class="ui">
    <div class="bar">
        <div class="errors">
            <img :class="wrongCssClass" :src="`${app_path}/assets/times.svg`" alt="Times">
            <span>{{ wrong }}</span>
        </div>
        
        <div class="correct">
            <span>{{ correct }}</span>
            <img :class="correctCssClass" :src="`${app_path}/assets/check.svg`" alt="Check">
        </div>
    </div>

    <div class="clock">
        <progress-ring radius=50 :progress="progress" stroke=6></progress-ring>
        <span>{{ time }}</span>
    </div>
</div>    
</template>

<script>
import ProgressRing from '@/components/ProgressRing.vue';
import EventBus from '@/EventBus.js';

export default {
    name: 'ui',
    components: {
        ProgressRing
    },
    props: ['wrong', 'time', 'correct', 'progress'],
    data() {
        return {
            animateCorrect: false,
            animateWrong: false,
            app_path: window.APP_PATH,
        }
    },
    computed: {
        correctCssClass() {
            if (this.animateCorrect) {
                return 'animated bounceIn';
            }
            return '';
        },
        wrongCssClass() {
            if (this.animateWrong) {
                return 'animated bounceIn';
            }
            return '';
        }
    },
    methods: {
        // Remove the animation css class after a short time period
        removeAnimationClass() {
            this.animateCorrect = false;
            this.animateWrong = false;
        },
        handleCorrect() {
            this.animateCorrect = true;
            window.setTimeout(this.removeAnimationClass, 600);
        },
        handleWrong() {
            this.animateWrong = true;
            window.setTimeout(this.removeAnimationClass, 600);
        }
    },
    mounted() {
        EventBus.on('on-correct-choice', this.handleCorrect);
        EventBus.on('on-wrong-choice', this.handleWrong);
    }
}
</script>

<style lang="scss">
.ui {
    font-family: 'Oswald-Light';
    position: relative;
    
    .bar {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;

        background-color: #fff;
        border-radius: 32px 32px;
        box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        height: 64px;
        width:90%;
        margin:0 auto;

        &>div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-around;

            height:100%;
            width: 25%;
            padding: 0 20px;
            
            img {
                width:20px;
            }
            span {
                line-height: 64px;
                font-size: 30px;           
            }
        }
    }

    .clock {
        box-sizing: content-box;
        width:77px;
        height:77px;
        border-radius: 100%;
       
        text-align: center;
        position: absolute;
        top:50%;
        left:50%;
        transform:translate(-50%, -50%);
        box-shadow: 0 10px 20px rgba(0,0,0,0.1);
       
       svg {
           position:relative;
           top:-12px;
           left:-12px;
       }
       
        span {
            position: absolute;
            top:50%;
            left: 50%;
            transform:translate(-50%,-50%);
            font-size:30px;
        }
    }
}
</style>
